module.exports = __webpack_public_path__ + "static/media/mcc_black.dbdf4fc1.png";